import React, { FC } from "react";
import { parseTemplateAsString } from "../../../../helpers/localization";
import { ComponentsLocalization } from "../../../../types/graphql/generated";
import { StyledNewPrice, StyledOldPrice, StyledPrice } from "./index.styled";

interface PriceProps {
  strikethroughUnitPrice?: string | null;
  perUnitPrice?: string | null;
  priceComponentLocalization: ComponentsLocalization["price"];
}

export const Price: FC<PriceProps> = ({
  strikethroughUnitPrice,
  perUnitPrice,
  priceComponentLocalization,
}) => {
  const {
    // eslint-disable-next-line no-template-curly-in-string
    eachPriceText = "${perUnitPrice} each",
    // eslint-disable-next-line no-template-curly-in-string
    regularPriceText = "Reg. ${strikethroughUnitPrice}",
  } = priceComponentLocalization ?? {};

  const getDisplayPrices = () => {
    if (strikethroughUnitPrice && perUnitPrice) {
      return (
        <div>
          <StyledNewPrice>
            {parseTemplateAsString(eachPriceText, {
              perUnitPrice,
            })}
            {/* {perUnitPrice} each */}
          </StyledNewPrice>
          <StyledOldPrice>
            {parseTemplateAsString(regularPriceText, {
              strikethroughUnitPrice,
            })}
            {/* Reg. {strikethroughUnitPrice} */}
          </StyledOldPrice>
        </div>
      );
    } else if (perUnitPrice) {
      return (
        <StyledPrice>
          {/* {perUnitPrice} each */}
          {parseTemplateAsString(eachPriceText, {
            perUnitPrice,
          })}
        </StyledPrice>
      );
    }

    return null;
  };

  return getDisplayPrices();
};
